import { Component, Input, NgModule, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';

@Component({
    selector: 'w-button-group',
    templateUrl: './w-button-group.component.html',
    standalone: false
})
/*
@id w-button-group
@name w-button-group
@status release
@description can take the same position as a single button, use if necessary
*/
export class WButtonGroupComponent implements OnInit {

  @Input() isNarrow = false; // takes half space
  @Input() fullHeight = false; // absolute position, takes full height of the parent (set parent relative)

  constructor() { }
  ngOnInit() { }
}
@NgModule({
  imports: [CommonModule],
  exports: [WButtonGroupComponent],
  declarations: [WButtonGroupComponent]
})
export class WButtonGroupModule { }
